import CustomLottie from '@/components/custom-lottie';
import { GapMagtekSdkContext } from '@/pages/(gapsdk)/_provider/gap-magtek-sdk-provider';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useContext, useEffect } from 'react';

const PaymentRemoveCardSuccessful = (props: { onBack: () => void }) => {
  const { event } = useContext(SoundContext);

  const { paymentStatus } = useContext(GapMagtekSdkContext);

  useEffect(() => {
    if (!paymentStatus) {
      event.playRemoveCard();
      props.onBack();
    }
  }, [paymentStatus]);

  return (
    <div className="relative flex h-full flex-col items-center justify-end bg-white">
      <p className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-5xl font-bold">
        Please remove card
      </p>
      <div className="absolute bottom-0 left-1/2 flex -translate-x-1/2 flex-col items-center gap-4">
        <CustomLottie
          path="/images/lotties/insert-card-large.json"
          className="size-[48px]"
          loop={true}
        />
        <CustomLottie
          path="/images/lotties/payment-successful-remove-card.json"
          className="h-[284px] w-[304px]"
          loop={true}
        />
      </div>
    </div>
  );
};

export default PaymentRemoveCardSuccessful;
